// Terrain - Simple platform for the character
import * as THREE from 'three';
import { Rendering } from '../Rendering';

export class Terrain {
    public group: THREE.Group;

    constructor() {
        this.group = new THREE.Group();
        this.createPlatform();
        Rendering.getInstance().scene.add(this.group);
    }

    private createPlatform(): void {
        // Create a large ground plane
        // Positioned at x=-12 to match character position
        const geometry = new THREE.CircleGeometry(20, 32);
        const material = new THREE.MeshStandardMaterial({
            color: 0xffffff, // White/Snow feeling
            roughness: 1,
            metalness: 0,
        });
        const ground = new THREE.Mesh(geometry, material);
        ground.rotation.x = -Math.PI / 2;
        ground.position.set(-12, -0.1, 0); // Under the character
        ground.receiveShadow = true;
        this.group.add(ground);

        // Add a soft shadow/AO blob under the character
        const blobGeo = new THREE.CircleGeometry(1.5, 32);
        const blobMat = new THREE.MeshBasicMaterial({
            color: 0x000000,
            transparent: true,
            opacity: 0.2,
        });
        const blob = new THREE.Mesh(blobGeo, blobMat);
        blob.rotation.x = -Math.PI / 2;
        blob.position.set(-12, 0.01, 0); // Slightly above ground
        this.group.add(blob);
    }

    update(_delta: number): void {
        // No updates needed
    }
}
